import { useSearchParams } from "react-router-dom";
import Contact from "@/components/laneeka/Contact";

export default function ContactPage() {
  const [params] = useSearchParams();
  return (
    <main data-testid="contact-page" className="pt-[108px]">
      <section className="bg-slate-50 border-b border-slate-200 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-700 mb-3">Get in touch</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Contact us</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">
            We make it our priority to respond to every request within 24 hours.
          </p>
        </div>
      </section>
      <Contact preselectedProduct={params.get("product") || ""} />
    </main>
  );
}
